"use strict";
var ɵngcc0 = require('@angular/core');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var HighchartsStatic = (function () {
    function HighchartsStatic() {
    }
HighchartsStatic.ɵfac = function HighchartsStatic_Factory(t) { return new (t || HighchartsStatic)(); };
HighchartsStatic.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: HighchartsStatic, factory: function (t) { return HighchartsStatic.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HighchartsStatic, [{
        type: core_1.Injectable
    }], function () { return []; }, null); })();
    return HighchartsStatic;
}());
exports.HighchartsStatic = HighchartsStatic;
var HighchartsService = (function () {
    function HighchartsService(highchartsStatic) {
        this._highchartsStatice = highchartsStatic;
    }
    HighchartsService.prototype.getHighchartsStatic = function () {
        return this._highchartsStatice;
    };
HighchartsService.ɵfac = function HighchartsService_Factory(t) { return new (t || HighchartsService)(ɵngcc0.ɵɵinject(HighchartsStatic)); };
HighchartsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: HighchartsService, factory: function (t) { return HighchartsService.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HighchartsService, [{
        type: core_1.Injectable
    }], function () { return [{ type: HighchartsStatic }]; }, null); })();
    return HighchartsService;
}());
HighchartsService = __decorate([ __metadata("design:paramtypes", [HighchartsStatic])
], HighchartsService);
exports.HighchartsService = HighchartsService;

